"use client";

import ShoppingListToast from "@/app/components/shopping-list-toast/shoppingListToast";
import Button from "@/components/design-system/button";
import { usePathname, useRouter } from "next/navigation";
import React, { FunctionComponent } from "react";
import style from "./addToShoppingList.module.scss";

const AddToShoppingList: FunctionComponent<AddToShoppingListProps> = ({
  user,
  isInShoppingList,
  mpId,
  onSubmitToShoppingList,
}) => {
  const router = useRouter();
  const pathname = usePathname();

  const handleAddToShoppingList = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (user?.IsGuestUser || (user?.IsGuestUser === false && user?.isAuthorized === false)) {
      const encodedPathName = encodeURIComponent(pathname + "?addItemToShoppingList");
      router.push("/login?origin=" + encodedPathName);
    } else {
      onSubmitToShoppingList(mpId);
    }
  };

  return (
    <>
      {user && user?.IsGuestUser === false && isInShoppingList && (
        <div className={style.shoppingListContainer} id="add-to-shopping-list">
          <span className={style.saveForLater}>Saved for Later:</span>
          <Button
            variant="tertiary"
            color="blue"
            size="small"
            text="View Shopping List"
            showLeftIcon={false}
            showRightIcon={false}
            link={{ href: "/shopping-list" }}
          />
        </div>
      )}
      {!isInShoppingList && (
        <form id="add-to-shopping-list" className={style.shoppingListContainer} onSubmit={handleAddToShoppingList}>
          <span className={style.saveForLater}>Save for Later:</span>
          <Button
            variant="tertiary"
            color="blue"
            size="small"
            text="Add to Shopping List"
            showLeftIcon={false}
            showRightIcon={false}
            type="submit"
          />
        </form>
      )}
      <ShoppingListToast />
    </>
  );
};

export type AddToShoppingListProps = {
  user: UserState | undefined;
  isInShoppingList: boolean;
  mpId: number;
  onSubmitToShoppingList: (mpId: number) => void;
};

export default AddToShoppingList;
